<script lang="ts">
import { defineComponent } from 'vue';
export default defineComponent({
  name: 'Tooltip',
  props: {
    text: {
      type: String,
      default: ''
    },
  }
});
</script>

<template>
  <div class="tooltip">
    <span class="tooltiptext">{{ text }}</span>
    <slot />
  </div>
</template>

<style>

.tooltip .tooltiptext {
  display: none;
  background-color: black;
  font-size: 12px;
  opacity: 50%;
  color: #fff;
  text-align: center;
  border-radius: 6px;
  padding: 5px;
  margin-left: 30px;

  /* Position the tooltip */
  position: absolute;
  z-index: 1;
}

.tooltip:hover .tooltiptext {
  display: block;
}
</style>
